module.exports = "<div>\r\n  <rw-privacy-policy>\r\n  </rw-privacy-policy>\r\n\r\n  <span>\r\n    -\r\n  </span>\r\n\r\n  <rw-terms-of-use>\r\n  </rw-terms-of-use>\r\n\r\n  <span ng-if=\"$ctrl.homePageLink.filePath\">\r\n    -\r\n  </span>\r\n\r\n  <a ng-if=\"$ctrl.homePageLink.filePath\"\r\n     href=\"{{ $ctrl.homePageLink.filePath }}\">\r\n    {{ $ctrl.homePageLink.translations[$ctrl.locale] }}\r\n  </a>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-homepage-links/rw-homepage-links.html
// module id = 1972
// module chunks = 0